import jQuery from 'jquery';

const modifier = {
    up: 'RC-oddsRunnerContent__price_priceUp',
    down: 'RC-oddsRunnerContent__price_priceDown',
    updateUpAnimation: 'RC-oddsRunnerContent__price_priceUpdateUp',
    changeUpAnimation: 'RC-oddsRunnerContent__price_priceChangeUp',
    updateDownAnimation: 'RC-oddsRunnerContent__price_priceUpdateDown',
    changeDownAnimation: 'RC-oddsRunnerContent__price_priceChangeDown',
    upTransition: 'RC-oddsRunnerContent__price_priceUpTransition',
    downTransition: 'RC-oddsRunnerContent__price_priceDownTransition',
    noPointer: 'RC-oddsRunnerContent__price_noPointer'
};

export default class AnimationHandler {
    constructor() {
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.onAnimationEnd = this.onAnimationEnd.bind(this);
    }

    init() {
        const transitionEnd = 'webkitTransitionEnd msTransitionEnd transitionend';
        const animationEnd = 'webkitAnimationEnd msAnimationEnd animationend';
        const $document = jQuery(document);
        $document.on(transitionEnd, '.js-RC-oddsPriceContainer', this.onTransitionEnd);
        $document.on(animationEnd, '.js-RC-oddsPriceContainer', this.onAnimationEnd);
    }

    /**
     * @private
     */
    onTransitionEnd({ target: priceElement }) {
        const tableCellClassList = priceElement.parentNode.classList;
        const $priceElement = jQuery(priceElement);
        const historyPriceValue = $priceElement.data('HistoryPrice');
        const orderingValue = $priceElement.data('OrderingValue');
        const newPrice = $priceElement.data('NewPrice');
        // eslint-disable-next-line no-param-reassign
        priceElement.innerHTML = newPrice;
        priceElement.classList.remove(modifier.downTransition, modifier.upTransition);
        if (orderingValue > historyPriceValue) {
            if (tableCellClassList.contains(modifier.down)) {
                tableCellClassList.add(modifier.changeUpAnimation);
            } else {
                tableCellClassList.add(modifier.updateUpAnimation);
            }
        } else if (tableCellClassList.contains(modifier.up)) {
            tableCellClassList.add(modifier.changeDownAnimation);
        } else {
            tableCellClassList.add(modifier.updateDownAnimation);
        }
    }

    /**
     * @private
     */
    onAnimationEnd({ target: priceElement }) {
        priceElement.classList.remove(
            modifier.changeUpAnimation,
            modifier.updateUpAnimation,
            modifier.changeDownAnimation,
            modifier.updateDownAnimation
        );
    }

    clearPriceEffects(priceElement) {
        priceElement.parentNode.classList.remove(modifier.down, modifier.up);
    }

    markPriceDelta(renderConfig, isTransitionRequired) {
        const priceElement = renderConfig.priceElement;
        function changeClass(classtoRemove, classToAdd) {
            const tableCellClassList = priceElement.parentNode.classList;
            tableCellClassList.remove(classtoRemove);
            tableCellClassList.add(classToAdd);
        }
        const priceValue = renderConfig.orderingValue;
        const historyPriceValue = renderConfig.historyPrice;
        const linkClassList = priceElement.classList;

        const isNoDelta = !priceValue || !historyPriceValue || priceValue === historyPriceValue;

        this.setPointerEnabled(priceElement, true);

        if (isNoDelta) {
            return;
        }
        const isPriceGrow = priceValue > historyPriceValue;

        if (isTransitionRequired) {
            const addClass = isPriceGrow
                ? modifier.upTransition
                : modifier.downTransition;
            linkClassList.add(addClass);
        }
        if (isPriceGrow) {
            changeClass(modifier.down, modifier.up);
        } else {
            changeClass(modifier.up, modifier.down);
        }
    }

    setPointerEnabled(priceElement, pointerEnabled) {
        if (pointerEnabled) {
            priceElement.classList.remove(modifier.noPointer);
        } else {
            priceElement.classList.add(modifier.noPointer);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/oddsTabHandler/AnimationHandler.js